module.exports = __webpack_public_path__ + "static/temoignage1-bc4f671dc951e05a5cd6938d0c3c9824.png";